// Please put date in YYYY-MM-DD format
export const singPhotos = [
    {
        name: "SophFrosh SING! 2018",
        desc: "Khandy's breakout whip piece exposure!",
        date: "2018-03-14",
    	imgname : "sophfrosh-sing-2018-0.png",
    	credits: "Khandy",
    },
    {
        name: "SophFrosh SING! 2018",
        desc: "Crew picture at Gibneys Studio H.",
        date: "2018-02-24",
    	imgname : "sophfrosh-sing-2018-1.png",
    	credits: "Khandy",
    },
    {
        name: "SophFrosh SING! 2018",
        desc: "Crew picture in cafeteria on show day.",
        date: "2018-03-14",
    	imgname : "sophfrosh-sing-2018-2.png",
    	credits: "Khandy",
    },
    {
        name: "SophFrosh SING! 2018",
        desc: "@ Brooklyn Bridge Park. \nFrom left to right: Talia, Alice, Matthew, Maggie, Heiley, Steve, Wentao, Justin, Khandy, Joanna",
        date: "2018-02-25",
    	imgname : "sophfrosh-sing-2018-3.png",
    	credits: "Khandy",
    },
    {
        name: "SophFrosh SING! 2018",
        desc: "@ Brooklyn Bridge Park but at night. From left to right: Matthew, Corinne, Khandy, Ken, Steve, Wentao",
        date: "2018-03-25",
    	imgname : "sophfrosh-sing-2018-4.png",
    	credits: "Khandy",
    },
    {
        name: "SophFrosh SING! 2018 Beginner Stringers",
        desc: "Beginner stringers, from left to right: Heiley, Steve, Joanna, Justin, Kaitlyn.",
        date: "2018-02-25",
    	imgname : "sophfrosh-sing-2018-6.png",
    	credits: "Khandy",
    },
    {
        name: "Junior SING! 2019 Studio",
        desc: "Studio day. Juniors found dead.",
        date: "2019-03-01",
    	imgname : "junior-sing-2019-0.png",
    	credits: "Khandy",
    },
    {
        name: "Junior SING! 2019 Crew",
        desc: "Group picture after show day. Very serious. Khandy MIA.",
        date: "2019-03-14",
    	imgname : "junior-sing-2019-1.png",
    	credits: "Khandy",
    },
    {
        name: "Junior SING! 2019 Directors",
        desc: "The directors of Junior SING! 2019. From left to right: Heiley, Maggie, Corinne, Joanna.",
        date: "2019-03-14",
    	imgname : "junior-sing-2019-2.png",
    	credits: "Khandy",
    },
    {
        name: "Junior SING! 2019 Backstage",
        desc: "Show day, backstage funtimes. From left to right: Colin, Jasmine, Kaitlyn, Kasey, Wentao, Umana.",
        date: "2019-03-15",
    	imgname : "junior-sing-2019-3.png",
    	credits: "Khandy",
    },
    {
        name: "Junior SING! 2020 Backstage",
        desc: "Post show, with the cool lights. Crew picture!",
        date: "2020-03-06",
    	imgname : "junior-sing-2020-0.png",
    	credits: "yeet",
    },
    {
        name: "Senior SING! 2020 Gym",
        desc: "Show date, the final show. Crew picture!",
        date: "2020-03-06",
    	imgname : "senior-sing-2020-0.png",
    	credits: "yeet",
    },
    {
        name: "Senior SING! 2020 Other Gym",
        desc: "Show date, the first day. Crew picture!",
        date: "2020-03-04",
    	imgname : "senior-sing-2020-1.png",
    	credits: "yeet",
    },
    {
        name: "SophFrosh SING! 2019 Gym",
        desc: "Crew picture of SophFrosh SING! 2019. Look at them small children.",
        date: "2019-03-13",
    	imgname : "sophfrosh-sing-2019-0.png",
    	credits: "yeet",
    },
    {
        name: "SophFrosh SING! 2019 Studio",
        desc: "Having fun at studio. Why didn't they invite me.",
        date: "2019-03-01",
    	imgname : "sophfrosh-sing-2019-1.png",
    	credits: "Renee",
    },
    {
        name: "SophFrosh SING! 2019 Backstage",
        desc: "On show day. Low quality picture of a high quality crew.",
        date: "2019-03-13",
    	imgname : "sophfrosh-sing-2019-2.png",
    	credits: "yeet",
    },
    {
        name: "SophFrosh SING! 2020 Atrium",
        desc: "Wow look at them go. Crew picture!",
        date: "2020-03-05",
    	imgname : "sophfrosh-sing-2020-0.png",
    	credits: "yeet",
    },
    {
        name: "SophFrosh SING! 2020 Backstage",
        desc: "Show date, post-performance.",
        date: "2020-03-05",
    	imgname : "sophfrosh-sing-2020-1.png",
    	credits: "yeet",
    },
    {
        name: "SophFrosh SING! 2020 Studio",
        desc: "Classic Gibneys Studio H mirror picture. Seniors were in Studio Y that day :)",
        date: "2020-02-26",
    	imgname : "sophfrosh-sing-2020-2.png",
    	credits: "Caroline",
    },

]
